import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwMessage, DwMessageSeverity, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { PaymentAddCardRequest } from '../../models/payment-add-card-request.model';
import { PaymentRepositoryService } from '../../services/payment-repository.service';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { AddPaymentMethodConfig } from '../../actions/add-payment-method/model/add-payment-method-config.model';
import { CheckRideRequestPaymentPartyAllItems } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-add-card-modal',
  templateUrl: './add-card-modal.component.html',
  styleUrls: ['./add-card-modal.component.scss']
})
export class AddCardModalComponent implements OnInit, DwModalHandler {

  constructor(private paymentRespositoryService: PaymentRepositoryService) { }
  
  modalConfig: DwModalConfig<AddPaymentMethodConfig>;

  closeModal = new EventEmitter<DwModalResult>();
  message: DwMessage;

  cardAddRequest: PaymentAddCardRequest = {
    cardDetails: {} as any,
    makeDefaultCard: true,
    paymentPartyId : CheckRideRequestPaymentPartyAllItems.PilotExaminer,
  }

  showAddTestCardInfo: boolean = false;

  ngOnInit(): void {
     this.showAddTestCardInfo = environment.production === false;

     this.cardAddRequest.paymentPartyId = this.modalConfig.data?.paymentPartyId || CheckRideRequestPaymentPartyAllItems.PilotExaminer;
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const modalResult = new DwModalResult();

    modalResult.closeModal = true;
    modalResult.cancelled = false;
    modalResult.buttonCommand = buttonConfig.command;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:

        if (!this.validateForm()) {
          modalResult.closeModal = false;

          return of(modalResult);
        }

        return this.addCard();
      default:
        // Otherwise we're cancelling
        modalResult.cancelled = true;

        return of(modalResult);
    }
  }

  addCard(): Observable<DwModalResult<any>> {
     const modalResult = new DwModalResult();

    modalResult.closeModal = true;
    modalResult.cancelled = false;

    return this.paymentRespositoryService.addCard(this.cardAddRequest)
      .pipe(map(result => {
          if (!result.IsSuccess) {
            this.setMessage(result.ErrorMessage, DwMessageSeverity.error);
            modalResult.closeModal = false;
          } else {
            modalResult.closeModal = true;
          }

          modalResult.data = result;

          return modalResult;
      }));
  }

  protected validateForm(): boolean {
    const errors: string[] = [];

    // Validate card details if not using a saved card
    if (!this.cardAddRequest.cardDetails?.cardholderName) {
      errors.push('Cardholder Name is required');
    }

    if (!this.cardAddRequest.cardDetails?.cardNumber) {
      errors.push('Card number is required');
    }

    if (!this.cardAddRequest.cardDetails?.expirationMonth) {
      errors.push('Expiration Month is required');
    }

    if (!this.cardAddRequest.cardDetails?.expirationYear) {
      errors.push('Expiration Year is required');
    }

    if (!this.cardAddRequest.cardDetails?.cVC) {
      errors.push('CVC is required');
    }

    if (!this.cardAddRequest.cardDetails?.cardholderPostalCode) {
      errors.push('Postal Code is required');
    }

    if (errors.length > 0) {
      this.setMessage(errors.join(", "), DwMessageSeverity.error);

      return false;
    }

    this.message = null;

    return true;
  }


  private setMessage(messageBody: string, severity: DwMessageSeverity = DwMessageSeverity.info) {
    this.message = {
      messageBody: messageBody,
      severity: severity
    };
  }
}